import { useCurrentUserContext } from '@/modules/auth/hooks/useCurrentUserContext';
import { PageHeader } from '@/modules/common/components/PageHeader';
import { useGetEmployers } from '@/modules/common/hooks/useEmployer';
import { ListOfCompaniesPageSearchParams } from '@/types/company';
import { List } from '@mui/icons-material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Tab from '@mui/material/Tab';
import { getRouteApi } from '@tanstack/react-router';
import { PaginationState } from '@tanstack/react-table';
import { ListOfCompaniesTable } from '../components/ListEmployeesTable';

const routeApi = getRouteApi('/_admin/companies/');

export function ListOfCompaniesPage() {
  const userContext = useCurrentUserContext();
  const search = routeApi.useSearch() as ListOfCompaniesPageSearchParams;
  const navigate = routeApi.useNavigate();

  const {
    isLoading,
    isRefetching,
    data: { data: companies = [], metadata: { total = 0, page = 1 } = {} } = {},
    refetch: refetchCompanies,
  } = useGetEmployers(
    {
      taxBenefitsProvider: userContext?.taxBenefitsProvider?._id ?? '',
    },
    {
      page: search.page,
      limit: 10,
    },
    { enabled: !!userContext?.taxBenefitsProvider },
  );

  const paginationState = {
    pageIndex: (page ?? 1) - 1 || 0,
    pageSize: 10,
  };

  const onPaginationChange = ({ pageIndex }: PaginationState) => {
    navigate({
      search: (prev: Record<string, unknown>) => ({
        ...prev,
        page: pageIndex + 1,
      }),
    });
  };

  return (
    <TabContext value="list">
      <div className="flex flex-col h-full">
        <PageHeader pageTitle="Managed Companies" />
        <TabList className="px-8 border-b mt-8">
          <Tab
            value="list"
            label={
              <div className="flex gap-2">
                <List />
                List
              </div>
            }
          />
        </TabList>
        <TabPanel value="list">
          <div className="flex gap-12 px-8 py-6">
            <div className="flex items-center"></div>
          </div>
          <div className="flex-1 p-12">
            <ListOfCompaniesTable
              isLoading={isLoading || isRefetching}
              onPaginationChange={updater => {
                return typeof updater === 'function'
                  ? onPaginationChange(updater(paginationState))
                  : onPaginationChange(updater);
              }}
              onCompanyLinkUpdate={refetchCompanies}
              companies={companies}
              paginationState={paginationState}
              rowCount={total}
            />
          </div>
        </TabPanel>
      </div>
    </TabContext>
  );
}
